<template>
  <v-app>
    <component :is="this.$route.meta.layout || 'div'"></component>    
    
  </v-app>
</template>

<script>

export default {
  name: 'App',

  data: () => ({
    //
  }),
};
</script>
